import { useFinanceBalance } from '@/api/models/finance'

export const useFinanceBalanceMain = () => {
  const { data, isLoading, isFetching, refetch, isError, error } =
    useFinanceBalance()

  return {
    data,
    isLoading,
    isFetching,
    refetch,
    isError,
    error
  }
}
